import * as Constants from "../../constants"
import axios from 'axios';
import WindIcon from '../../assets/img/icons-storm/wind.svg';
import TornadoIcon from '../../assets/img/icons-storm/tornado.svg';
import HailIcon from '../../assets/img/icons-storm/hail.svg';
import RainIcon from '../../assets/img/icons-storm/rain.svg';
import FoodIcon from '../../assets/img/icons-storm/flood.svg';
import SnowIcon from '../../assets/img/icons-storm/snow.svg';
import LightningIcon from '../../assets/img/icons-storm/lightning.svg';
import IceIcon from '../../assets/img/icons-storm/ice.svg';
import CautionIcon from '../../assets/img/icons-storm/caution.svg';

export interface StormReport {
    position: number[],
    icon: {
        url: string,
        size: number[],
        anchor: number[]
    },
    text: string
}
interface StormFeature {
    geometry:{
        coordinates: number[],
        type: String
    },
    properties: {
        angle: number,
        fileName: String,
        iconHeight: number,
        iconHotX: number,
        iconHotY: number,
        iconNumber: number,
        iconWidth: number,
        imageHeight: number,
        imageWidth: number,
        text: String,
    },
    type: String
}
export class StormReportsService {
    constructor() {
    }
    
    async getStormReports()   {
        try {
            
            const response = await axios.get(Constants.STORM_REPORTS_API_URL ?? '');
            if (response.status == 200 && response.data && response.data.features){
                return this.processData(response.data.features);
            }else{
                return [];
            }
            
            
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    processData(reports:StormFeature[]):StormReport[]{
        const markers: StormReport[] = [];
        reports.forEach((report:StormFeature) => {
            if(report.geometry && report.geometry.type == "Point" && report.geometry.coordinates
                && report.properties && report.properties.iconNumber>0 && report.properties.text){
                markers.push(this.getMarker(report));
            }
        });
        return markers;
    }

    getMarker(data: StormFeature): StormReport {
        const report = {
            coords: {
                lat: data.geometry.coordinates[1],
                lon: data.geometry.coordinates[0]
            },
            icon: data.properties.iconNumber,
            text: data.properties.text
        }
        const icon = {
            url: this.getImageUrl(report.icon),
            size: [data.properties.iconWidth ?? 32, data.properties.iconHeight ?? 32],
            anchor: [16, 16]
        };
        
        return <StormReport>{
            position: [report.coords.lat, report.coords.lon],
            icon: icon,
            text: report.text
        }
        
    }

    getReportContent(reportText: StormReport['text']) {
        const rows = reportText.split(/\n|\\n/).filter(row => row.trim());
        const result: any = {};
        
        rows.forEach(row => {
            const parts = row.split(':');
            const key = parts.shift()?.trim();
            let value = parts.join(':').trim().split(" UTC").join("");
            
            if (key === 'Date') {
                const currentYear = new Date().getFullYear();
                const [month, day, time] = value.split(' ');
                const [hours, minutes, seconds] = time.split(':');
                
                result.date = `${month} ${day} ${currentYear}`;
                result.time = `${hours}:${minutes}:${seconds}`;
            } else {
                if (key && value) {
                    result[key.toLowerCase()] = value;
                }
            }
        });
        return result;
    }

    getTextReport(text: string){
        let content = '';
        const rows = text.split('\\n');
        rows.forEach((row: string) => {
            const parts = row.split(':');
            content += this.createLabelHtml(parts.shift()+':');
            content += this.createValueHtml(parts.join(':').split(" UTC").join(""));
        });
        return content;
    }
    createLabelHtml(title: string) {
        return '<span style=" font-weight: bold;">' + title + '</span>';
    }
    createValueHtml(title:string) {
        return '<span>' + title + '</span><br/>';
    }

    getImageUrl (icon: number) : string {
        let img = WindIcon;
        switch (icon) {
            case 7:
                img = HailIcon;
                break;
            case 4:
            case 5:
            case 6:
            case 26:
            case 30:
            case 32:
                img = WindIcon;
                break;
            case 13:
                img = RainIcon;
                break;
            case 11:
            case 12:
                img = FoodIcon;
                break;
            case 19:
            case 20:
                img = SnowIcon;
                break;
            case 1:
            case 2:
                img = TornadoIcon;
                break;
            case 10:
                img = LightningIcon;
                break;
            case 31:
                img = IceIcon;
                break;
            default:
                img = CautionIcon;
        }

        return img;
    }
    
}
